export default {
  product: {
    title: 'ผลิตภัณฑ์',
    selfCustodyWallet: 'กระเป๋าเงินมือถือ',
    selfCustodyWalletDesc: 'คริปโต&DeFi กระเป๋าเงินมือถือ บนบล็อคเชน',
    hardwareWallet: 'กระเป๋าเงินฮาร์ดแวร์',
    hardwareWalletDesc: 'รับ KeyPal ของคุณเพื่อปกป้องทรัพย์สินของคุณ',
    extensionWallet: 'กระเป๋าสเงินเสริม',
    extensionWalletDesc: 'กระเป๋าเงินที่ดีกว่าบนคอมพิวเตอร์ของคุณ',
    transit: 'ขนส่ง',
    transitDesc: 'Multi-chain DEX Aggregator และ  NFT Marketplace แพลตฟอร์ม',
    fiveDegrees: '5องศา',
    fiveDegreesDesc: 'โซเชียลเน็ตเวิร์กโปรโตคอลใน Web3.0',
    stakeVault: 'ETH Staking Vault',
    stakeVaultDesc:
      'สนับสนุนทั้ง self-custodial staking และ small amount staking',
  },
  project: {
    subToken: 'ส่งโทเค็น',
    subDApp: 'ส่งดีแอป',
    subNFT: 'ส่ง NFT',
    subChain: 'ส่ง โซ่',
  },
  assets: {
    title: 'ทรัพย์สิน',
  },
  collaborations: {
    title: 'ความร่วมมือ',
  },
  community: {
    title: 'ชุมชน',
    developers: 'นักพัฒนา',
    recruiting: 'ชายTP',
  },
  helpCenter: {
    title: 'ช่วย',
  },
  features: {
    title: 'คุณสมบัติ',
    buyCrypto: 'ซื้อคริปโต',
    mobileWallet: 'กระเป๋าเงินมือถือ',
    hardwareWallet: 'กระเป๋าเงินฮาร์ดแวร์',
    extensionWallet: 'กระเป๋าเงินเสริม',
    desktop: 'กระเป๋าเงินเดสก์ท็อป',
    fiveDegrees: '5องศา',
    versionVerification: 'Version Verification',
    approvalDetector: 'Approval Detector',
    tokenSecurity: 'ความปลอดภัยของโทเค็น',
    keyGenerator: 'ตัวสร้างคีย์',
    BATCH_SENDER: 'ผู้ส่งแบทช์',
  },
  information: {
    title: 'ข้อมูล',
    blockchainGuide: 'คู่มือบล็อคเชน',
    tronWallet: 'คู่มือ TRON',
    iostWallet: 'คู่มือ IOST',
    tpMan: 'ชาย TP',
  },
  developers: {
    title: 'นักพัฒนา',
    github: 'Github (TP-Labs)',
    devCenter: 'ศูนย์นักพัฒนา',
    subToken: 'ส่งโทเค็น',
    subDApp: 'ส่งดีแอป',
    subNFT: 'ส่ง NFT',
  },
  company: {
    title: 'บริษัท',
    about: 'กี่ยวกับ',
    careers: 'อาชีพ',
    pressKit: 'Press Kit',
    swagShop: 'Swag Shop',
  },
  support: {
    title: 'สนับสนุน',
    helpCenter: 'ศูนย์ช่วยเหลือ',
    contactUs: 'ติดต่อเรา',
  },
  legal: {
    title: 'ถูกกฎหมาย',
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
    terms: 'ข้อกำหนดการใช้งาน',
  },
  main: {
    title: 'การตรวจสอบเวอร์ชัน',
    language: 'ไทย',
    intro:
      'การตรวจสอบเวอร์ชันนั้น เป็นการเชื่อมโยงระหว่างค่าแฮช MD5 หรือ SHA256 ระหว่างเวอร์ชันต่างๆ โปรดตรวจสอบและดาวน์โหลด TokenPocket wallet ผ่านทางช่องทางอย่างเป็นทางการเพื่อป้องกันการถูกหลอกลวง สำหรับคำแนะนำเกี่ยวกับวิธีการรับค่าแฮช MD5 หรือ SHA256 ของเวอร์ชัน โปรด ',
    tutorial: 'อ่านคู่มือ >',
    system: 'ระบบปฏิบัติการ',
    android: 'Android',
    ios: 'iOS',
    version: 'เวอร์ชัน',
    allVersion: 'ทั้งหมด',
    appChannel: 'ช่องทางแอปพลิเคชัน',
    developer: 'นักพัฒนา',
    allChannel: 'ทั้งหมด',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'บันทึกเวอร์ชัน',
    check: 'รายละเอียด',
    versionLog: 'บันทึกเวอร์ชัน',
    confirm: 'ยืนยัน',
    aboutIOS: 'เกี่ยวกับเวอร์ชัน iOS',
    IOSDesc:
      'สำหรับเวอร์ชัน iOS เราให้บริการแอปเพียงแค่ใน App Store เท่านั้น แอปที่ดาวน์โหลดจาก App Store เท่านั้นที่จะติดตั้งได้อย่างถูกต้อง ดังนั้น กรุณายืนยัน App Store เป็นช่องทางดาวน์โหลดที่ถูกต้องสำหรับอุปกรณ์ Apple',
    IOSDesc_2:
      'นักพัฒนาของเวอร์ชันที่ดาวน์โหลดจาก App Store ก่อนวันที่ 8 ตุลาคม 2022 คือ TOKENPOCKET FOUNDATION LTD ซึ่งเป็นเวอร์ชันเริ่มต้นที่พัฒนาโดย TokenPocket นั่นเป็นกระเป๋าเงินที่ถูกต้องและสามารถใช้งานได้อย่างปกติ แต่การให้บริการการอัพเดตจะถูกระงับชั่วคราว',
    aboutAndroid: 'เกี่ยวกับเวอร์ชัน Android',
    androidDesc: 'ช่องทางดาวน์โหลด TokenPocket สำหรับ Android ปัจจุบันรวมถึงเว็บไซต์อย่างเป็นทางการ, ร้านค้า Google Play, ร้านค้าแอป Samsung, Huawei AppGallery, ร้านค้าแอป OPPO, และร้านค้าแอป Vivo. ในบางร้านค้าแอปไม่สามารถรับไฟล์ติดตั้ง APK ระหว่างขั้นตอนดาวน์โหลดได้เนื่องจากนั้นไม่สามารถทำการตรวจสอบ MD5 หรือ SHA256 ได้ ดังนั้นในการดาวน์โหลด กรุณาตรวจสอบข้อมูลผู้พัฒนาอย่างชัดเจนตามข้างล่าง!',
    IOSAppName: 'ชื่อแอปพลิเคชัน:',
    TPWallet: 'TP Wallet',
    AppIcon: 'ไอคอนแอปพลิเคชัน:',
    AppDeveloper: 'ผู้พัฒนา:',
    downloadLink: 'ลิงก์ดาวน์โหลด:',
    copied: 'คัดลอกแล้ว!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'ตามเรามา',
    desc1: 'พนักงาน TokenPocket จะไม่ส่งข้อความส่วนตัวถึงคุณ!',
    desc2:
      'คำเตือน! คุณกำลังเข้าสู่ชุมชน TokenPocket อาจมีใครบางคนแอบอ้างเราเพื่อส่งข้อความส่วนตัวถึงคุณ! โปรดทราบว่าทุกคนที่ส่งข้อความส่วนตัวอาจเป็นสแกมเมอร์! เราจะไม่ติดต่อคุณก่อน!',
    desc3: 'เข้าใจแล้ว ป้อน',
  },
};
